<div>
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-lg-12" style="width:100%">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
      </div>
    </div>
    <div style="padding:20px 20px 5px 20px;">
      <table class="table table-bordered table-hover">
        <thead>
          <colgroup>
            <col width="25%">
            <col width="25%">
            <col width="25%">
            <col width="25%">
          </colgroup>
          

          <tr style="background-color:#F9f9f9;">
            <th>
              <div class="center"><b>Sheet Name</b></div>
            </th>

            <th>
              <div class="center"><b>Column Name</b></div>
            </th>
            <th>
              <div class="center"><b>Label Name</b></div>
            </th>

          </tr>
        </thead>
        <tbody style="text-align:center;" >

          <tr *ngFor="let item of listLabelMapping">

            <td>
              {{item.SheetName}}
            </td>
            <td>
              {{item.ColumnName}}

            </td>
            <td>
              {{item.LabelName}}
            </td>

          </tr>
          

        </tbody>
      </table>
    </div>
  </div>
</div>